import { useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store.ts'
import { api } from './api.ts'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()

export const {
  useGetClientsQuery,
  useGetClientQuery,
  useCreateClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
  useGetProjectsQuery,
  useGetProjectsByClientQuery,
  useGetProjectQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
  useUploadProjectImageMutation,
  useDeleteProjectImageMutation,
  useGetProjectInventoryItemsQuery,
  useBulkAddProjectInventoryItemsMutation,
  useUpdateProjectInventoryItemMutation,
  useDeleteProjectInventoryItemMutation,
  useGetInventoryItemsQuery,
  useGetInventoryItemQuery,
  useCreateInventoryItemMutation,
  useUpdateInventoryItemMutation,
  useDeleteInventoryItemMutation,
  useUpdateProjectInventoryItemSortOrderMutation,
} = api
